import { NotificationChannel } from '../types/notification.types';

const CHANNEL_LABELS: Record<NotificationChannel, string> = {
  MESSAGING: 'Mensajes',
  MARKETING: 'Marketing',
  CALLS: 'Llamadas',
  SYSTEM: 'Sistema',
};

export const formatNotificationChannel = (
  channel: NotificationChannel
): string => {
  return CHANNEL_LABELS[channel] ?? channel;
};
